import './Actions.less';

import moment from 'moment';
import React, { useContext, useState } from 'react';
import { useReframe } from 'nike-re-framejs';

import { getConfigProperty } from '@/common/oldMobile';
import i18n from '@i18n';
import { Registered } from '@/mytickets/constants/ticketStatus';
import { ticketsFromLS } from '@/mytickets/saved/utils';
import Save from './Save';
import Claim from './Claim';
import CopyLink from './CopyLink';
import DeleteSavedOnProfile from './DeleteSavedOnProfile';
import DeleteSavedOnDevice from './DeleteSavedOnDevice';
import Notify from './Notify';
import Restore from './Restore';
import Share from './Share';
import Storno from './Storno';
import BetbookContext from 'nike-ui/src/common/BetbookContext';
import AddToBetbook from '@/mytickets/detail/views/Actions/AddToBetbook';
import { subscribed$ } from '@/notifications/subs';
import { accountCustomerId$ } from '@/account/subs';
import { createNikeTicketShareURL } from 'nike-ui/src/common/util';
import { AddToChat } from '@/mytickets/detail/views/Actions/AddToChat';

function Actions({ ticket }) {
    const { subscribe } = useReframe();
    const customerId = subscribe(accountCustomerId$);
    const { alias, bets, betStatusCounts, hash, ticketId } = ticket;
    const subscribed = subscribe(subscribed$(ticketId));
    const publicUrl = `${getConfigProperty('hostUrl')}/tiket${alias ? '-alias' : ''}/${alias || hash}`;
    const saved = ticket.source === 'Saved';
    const [isExpanded, setExpanded] = useState(false);
    const actionsStack = [];
    const betbookContext = useContext(BetbookContext);
    const isMyTicket = ticket.customerId === customerId;

    const shouldDisplayBetbookButton =
        isMyTicket &&
        !saved &&
        bets &&
        !betStatusCounts.Cancelled &&
        !betStatusCounts.Returned &&
        !bets.filter(bet => moment(bet.expirationDate).isBefore()).length;

    if (ticket.hasActiveBet) {
        actionsStack.push(
            <Restore
                key="RestoreAction"
                ticketId={ticketId}
                createDraftCmd={ticket.createDraftCmd}
                ticketType={ticket.type}
                saved={saved}
            />
        );
        if (!saved) {
            actionsStack.push(<Save key="SaveAction" ticketId={ticketId} />);
        }
    }
    if (!saved) {
        actionsStack.push(<AddToChat key="AddToChat" ticket={ticket} />);
    }

    if (!betbookContext.isBetbook) {
        if (!saved && customerId && isMyTicket) {
            actionsStack.push(<Claim key="ClaimAction" hash={hash} />);
            if (ticket.status === Registered) {
                actionsStack.push(<Notify key="NotifyTicketAction" subscribed={subscribed} ticketId={ticketId} />);
            }

            if (ticket.branchId && ticket.ticketNumber && ticket.cancellable) {
                actionsStack.push(
                    <Storno
                        key="StornoAction"
                        hash={hash}
                        branchId={ticket.branchId}
                        ticketNumber={ticket.ticketNumber}
                    />
                );
            }
        }
        if (shouldDisplayBetbookButton) {
            actionsStack.push(<AddToBetbook key="AddToBetbookAction" ticket={ticket} />);
        }

        actionsStack.push(<Share key="ShareAction" ticket={ticket} />);
        if (saved) {
            actionsStack.push(<AddToChat key="AddToChat" ticket={ticket} />);
        }
        actionsStack.push(
            <CopyLink key="CopyLinkAction" publicUrl={createNikeTicketShareURL(publicUrl, ticket.hash, 'copy')} />
        );
    }
    if (saved) {
        if (ticketsFromLS().some(t => t === ticketId)) {
            actionsStack.push(<DeleteSavedOnDevice key="DeleteSavedOnDeviceAction" ticket={ticket} />);
        } else if (customerId && isMyTicket) {
            actionsStack.push(<DeleteSavedOnProfile key="DeleteSavedOnProfileAction" ticket={ticket} />);
        }
    }

    const { length } = actionsStack;
    const numberOfButtonsToShow = isExpanded ? length : length > 4 ? 3 : length;

    function toggleExpanded() {
        setExpanded(!isExpanded);
    }

    return (
        <div className="ticket-actions">
            {actionsStack.slice(0, numberOfButtonsToShow)}
            {actionsStack.length > numberOfButtonsToShow && (
                <div className="show-more-actions blue-link" onClick={toggleExpanded}>
                    {i18n('common.showMore')}
                </div>
            )}
        </div>
    );
}

export default Actions;
